<template>

  <div>

    <div class="project-intro">
      <div class="preview">
        <img src="../../assets/portfolio/webworthy-screens.png" alt="Webworthy Design">
      </div>
      <div class="intro-text">
        <p>
          <a href="https://webworthy.design/" target="blank">Webworthy Design</a> 
          is my other website. This is the site I use when doing B2B work. 
          I designed this site as a way for other businesses to feel more comfortable when working 
          with me, being here I am positioned as another business myself. When it comes to Webworthy Design it's all me.
          I created the logo, branding... everything! So I thought it would be a great addition to my personal portfolio here! 
          Feel free to check out the <a href="https://webworthy.design/our-work/" target="blank">portfolio</a> 
          on that site too for more examples of my work.
        </p>
        <ul>
          <li>Branding</li>
          <!-- <li>UX</li> -->
          <!-- <li>UI</li> -->
          <li>Product Design</li>
          <li>Development</li>
        </ul>
      </div>
    </div>
    <div class="case-study">
      <div class="browser bar">
        <!-- <img src="../../assets/portfolio/webworthy-1.png" alt="Webworthy Design"> -->
        <img src="../../assets/portfolio/webworthy-full.jpg" alt="Webworthy Design">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/webworthy-scene-1.jpg" alt="Webworthy Design">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/webworthy-2.jpg" alt="Webworthy Design">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/webworthy-3.jpg" alt="Webworthy Design">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/webworthy-4.jpg" alt="Webworthy Design">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/webworthy-5.jpg" alt="Webworthy Design">
      </div>
    </div>

    <div class="project-outro">
      <div class="outro-text">
        <h2>Coded by hand, coded with care</h2>
        <p>
          Each line of code was purposefully thought out and written to ensure that 
          the site would be future friendly for browsers and devices. 
          Semantics are the foundation of this sites inner workings and a 
          skillful hand was required to assemble it.  
        </p>
        <p>
          The site was built using the most up to date technologies like HTML5 and CSS3. 
          WordPress was the content management system of choice due to its extreme 
          flexibility and emphasis on usability.
        </p>
      </div>
      <div class="outro-img">
        <img src="../../assets/portfolio/code.gif" alt="code">
      </div>
    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "webworthy",
  props: ["title", "subtitle", "hero"]
};
</script>

<style scoped lang="scss">
</style>
